"use client";

import { SectionTitle } from "./sectionTitle";

export const Theme = () => {
	return (
		<div className="flex flex-col gap-4">
			<SectionTitle title="テーマ" />
			<div className="text-black font-bold font-zenMaru text-xl text-left">
				持続可能な社会を作る
			</div>
		</div>
	);
};
